import { BigNumber } from '@frontend/numeric';

import { trimTrailingZero } from '../number';

export const convertVolumeToUnits = (
  volume: number | undefined,
  contractSize: number | undefined,
  lotSizeStep: number | undefined
) => {
  if (!contractSize || !lotSizeStep || !volume) {
    return volume?.toFixed(lotSizeStep ?? 0) ?? '';
  }
  const minUnitsBN = new BigNumber(lotSizeStep).times(contractSize);
  const unitsBN = new BigNumber(volume).times(contractSize);
  return trimTrailingZero(unitsBN.toFixed(minUnitsBN.decimalPlaces() || 0));
};
